export default __webpack_public_path__ + "locales/de/JavascriptSdk.json?hash=ae1fa64768fd1b270d0779bc0dff2dfe";